import { Box, Tooltip, Typography } from '@mui/material';
import { connectorText, describe } from './conditions';

/** The plain-English summary of a condition tree, with question names and AND / OR picked out. */
const LogicSummary = ({ logic, questions, joinUnknown = false, subject, variant = 'body2', sx }) => (
  <Typography variant={variant} sx={sx}>
    {describe(logic, questions, { joinUnknown, subject }).map((part, i) => {
      if (typeof part === 'string' || typeof part === 'number') return <span key={i}>{part}</span>;
      if (part.connector) {
        return (
          <Box key={i} component="strong" sx={{ color: part.connector === 'unknown' ? 'warning.dark' : 'primary.dark', mx: 0.25 }}>
            {' '}{connectorText(part.connector)}{' '}
          </Box>
        );
      }
      const name = <Box component="em" sx={{ fontWeight: 500 }}>{part.question}</Box>;
      return part.missing ? (
        <Tooltip key={i} title="This question isn't in the synced question list. Sync questions, or fix the logic.">
          <Box component="span" sx={{ color: 'error.main' }}>{name}</Box>
        </Tooltip>
      ) : <span key={i}>{name}</span>;
    })}
  </Typography>
);

export default LogicSummary;
